import axiosInstance from '../../../config/axiosInstance';
const handleInvoicing = async (formData) => {

    try {
        const CompanyID = localStorage.getItem("CompanyID");
        formData.ClientID = CompanyID;
        const UserID = localStorage.getItem("UserID");
        formData.UserID = UserID;
        const response = await axiosInstance.post(`/Job/CreateJobInvoicing`, formData);
        return response.data.LastInvoiceID;

    } catch (error) {
        console.error('Error posting data:', error);
    }

};

export { handleInvoicing };